export const setPasswordConstants = {
    
    SETPASSWORD_API: "/vendor/reset-password",


};
